import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Switch from '../../../base/ui/components/web/Switch';
// @ts-ignore
const useStyles = makeStyles((theme) => {
    return {
        switchContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        switchLabel: Object.assign(Object.assign({ marginRight: 10 }, theme.typography.bodyShortRegular), { lineHeight: `${theme.typography.bodyShortRegular.lineHeight}px` })
    };
});
/**
 * React component for toggling face expressions grid.
 *
 * @returns {React$Element<any>}
 */
export default function FaceExpressionsSwitch({ onChange, showFaceExpressions }) {
    const classes = useStyles();
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.switchContainer },
        React.createElement("label", { className: classes.switchLabel, htmlFor: 'face-expressions-switch' }, t('speakerStats.displayEmotions')),
        React.createElement(Switch, { checked: showFaceExpressions, id: 'face-expressions-switch', onChange: onChange })));
}
